import { route } from './config';
import { File } from './types';

export function dokumentUrl(file: File) {
  return `${route}/${file.type === 'folder' ? 'f' : 'd'}/${file.id}`;
}
